import styled from 'styled-components';
import { theme } from '../theme';

export const RoomListEmptyState = styled.div`
  text-align: center;
  padding: ${theme.spacing.xl} ${theme.spacing.lg};
  color: ${theme.colors.text.secondary};
`;

export const RoomListEmptyStateIcon = styled.div`
  font-size: 4rem;
  margin-bottom: ${theme.spacing.md};
  opacity: 0.5;
`;

export const RoomListEmptyStateText = styled.p`
  font-size: 1.1rem;
  margin: 0;
`;

export const RoomListEmptyStateSubtext = styled.p`
  font-size: 0.9rem;
  opacity: 0.7;
  margin-top: 0.5rem;
  margin: 0.5rem 0 0 0;
`;
